import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { translateDosageForm } from "@/entities/medicine/lib/medicine-label";
import type { GroupedFinderResult } from "./utils";
export function SharedSpecs(t0) {
  const $ = _c(14);
  const {
    shared
  } = t0;
  const {
    t
  } = useTranslation();
  let chips;
  if ($[0] !== shared.dosage_form || $[1] !== shared.pack || $[2] !== shared.strength || $[3] !== shared.vendor_country || $[4] !== shared.volume || $[5] !== t) {
    chips = [];
    if (shared.dosage_form) {
      let t1;
      if ($[7] !== shared.dosage_form) {
        t1 = translateDosageForm(String(shared.dosage_form)) ?? String(shared.dosage_form);
        $[7] = shared.dosage_form;
        $[8] = t1;
      } else {
        t1 = $[8];
      }
      chips.push(t1);
    }
    if (shared.strength) {
      chips.push(String(shared.strength));
    }
    if (shared.volume) {
      chips.push(String(shared.volume));
    }
    if (shared.pack != null) {
      const t1 = Number(shared.pack);
      let t2;
      if ($[9] !== t || $[10] !== t1) {
        t2 = t("medicines.labels.packPieces", {
          count: t1
        });
        $[9] = t;
        $[10] = t1;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      chips.push(t2);
    }
    if (shared.vendor_country) {
      chips.push(String(shared.vendor_country));
    }
    $[0] = shared.dosage_form;
    $[1] = shared.pack;
    $[2] = shared.strength;
    $[3] = shared.vendor_country;
    $[4] = shared.volume;
    $[5] = t;
    $[6] = chips;
  } else {
    chips = $[6];
  }
  if (chips.length === 0) {
    return null;
  }
  let t1;
  if ($[12] !== chips) {
    t1 = <p className="text-muted-foreground truncate text-xs">{chips.map(_temp)}</p>;
    $[12] = chips;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
}
function _temp(chip, index) {
  return <React.Fragment key={chip}>{index > 0 ? <span className="px-1.5 opacity-50">·</span> : null}{chip}</React.Fragment>;
}